import { MdTabletAndroid, MdPhoneAndroid, MdOutlineTabletMac } from "react-icons/md";
import "./device.css";

export function Devices() {
  const items = [
    {
      key: "rugged",
      title: "Android Tablet",
      text: "IP67-rated, long battery life, sunlight readable.",
      badge: "Offline First",
      icon: <MdTabletAndroid size={32} />,
      cta: { label: "View specs", href: "#rugged-specs" },
    },
    {
      key: "kiosk",
      title: "Android Phone Kiosk",
      text: "Low-cost wall mount with fingerprint reader.",
      badge: "Budget Friendly",
      icon: <MdPhoneAndroid size={32} />,
      cta: { label: "See mounts", href: "#kiosk-mounts" },
    },
    {
      key: "ipad",
      title: "iPad Setup",
      text: "Desk or wall mount with supported scanner.",
      badge: "iOS Ready",
      icon: <MdOutlineTabletMac size={32} />,
      cta: { label: "Compatible scanners", href: "#ipad-scanners" },
    },
  ];
  

  return (
    <section id="devices" className="section section--alt">
      <div className="container">
        <h2 className="section__title">Device options</h2>

        <div className="devices">
          {items.map((d) => (
            <article key={d.key} className={`devicecard devicecard--${d.key}`}>
              <div className="devicecard__glow" aria-hidden="true" />
              <div className="devicecard__head">
                <span className="devicecard__icon">{d.icon}</span>
                <span className="devicecard__badge">{d.badge}</span>
              </div>
              <h3 className="devicecard__title">{d.title}</h3>
              <p className="devicecard__text">{d.text}</p>
              {/* <div className="devicecard__actions">
                <a className="btn btn--light" href={d.cta.href}>{d.cta.label}</a>
              </div> */}
            </article>
          ))}
        </div>

        {/* tiny legend row (optional) */}
        <ul className="devices__legend">
          <li><span className="dot dot--rugged" /> Android</li>
          <li><span className="dot dot--kiosk" /> Phone Kiosk</li>
          <li><span className="dot dot--ipad" /> iPad Setup</li>
        </ul>
      </div>
    </section>
  );
}
